import { call, put } from "redux-saga/effects";
import * as api from "../../services/api";
import ProviderBanksActions from "./provider-banks-actions";

export function* getProviderBankList(action) {
  const { filters, options } = action;
  const response = yield call(api.getBanks, filters, options);
  if (response.ok) {
    yield put(ProviderBanksActions.providerBankListSuccess(response.data));
  } else {
    yield put(ProviderBanksActions.providerBankListFailure(response.data));
  }
}

export function* getProviderBanksCount(action) {
  const { filters } = action;
  const response = yield call(api.getBanksCount, filters);
  if (response.ok) {
    yield put(ProviderBanksActions.providerBanksCountSuccess(response.data));
  } else {
    yield put(ProviderBanksActions.providerBanksCountFailure(response.data));
  }
}

export function* updatePaystackReveknewSubaccountBanks(action) {
  const { payload } = action;
  const response = yield call(api.updatePaystackReveknewSubaccountBanks, payload || {});
  if (response.ok) {
    yield put(ProviderBanksActions.paystackReveknewBankUpdateSuccess(response.data));
  } else {
    yield put(ProviderBanksActions.paystackReveknewBankUpdateFailure(response.data));
  }
}
